import { render, staticRenderFns } from "./wine-lovers-registration2.vue?vue&type=template&id=2134ae4e&scoped=true"
import script from "./wine-lovers-registration2.vue?vue&type=script&lang=js"
export * from "./wine-lovers-registration2.vue?vue&type=script&lang=js"
import style0 from "./wine-lovers-registration2.vue?vue&type=style&index=0&id=2134ae4e&prod&scoped=true&lang=css"
import style1 from "./wine-lovers-registration2.vue?vue&type=style&index=1&id=2134ae4e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2134ae4e",
  null
  
)

export default component.exports